import React, { useState } from 'react'
import { get, post } from 'aws-amplify/api'
import FormsContext from '../context/FormsContext'
import { useAuth0 } from '@auth0/auth0-react'
import errorTrackingService from '../services/errorTrackingService'

const ids = {
  historial: {
    general: 1,
    ginecologia: 2,
    psicologia: 4,
    sueno: 5,
    nutricion: 8,
    alimentacion: 9,
    obstetricia: 10,
    vacunas: 12
  },
  maternidad: {
    calculadora: 16
  }
}

const FormsProvider = ({ children }) => {
  const [saveResponse, setSaveResponse] = useState({})

  const { getIdTokenClaims } = useAuth0()
  const baseUrl = process.env.REACT_APP_API_BASE_URL

  const getFormQuestions = async (id, location) => {
    const idToken = await getIdTokenClaims()

    try {
      const resp = get({
        apiName: baseUrl,
        path: `/admin/getMedicalHistoryTemplate?template_id=${ids[location][id]}`,
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()

      if (data.success === false) {
        const error = new Error(data.message || 'API returned success: false')
        error.isAPIError = true
        error.response = { status: 200, data }
        errorTrackingService.trackAPIError(error, '/admin/getMedicalHistoryTemplate', 'GET')
        return undefined
      }

      return data.body
    } catch (error) {
      errorTrackingService.trackAPIError(error, '/admin/getMedicalHistoryTemplate', 'GET')
      console.log(error)
      return undefined
    }
  }

  const postAnswers = async (body, id, location) => {
    const idToken = await getIdTokenClaims()

    try {
      const resp = post({
        apiName: baseUrl,
        path: `/admin/setMedicalHistory?template_id=${ids[location][id]}`,
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          },
          body
        }
      })
      const { body: responseBody } = await resp.response
      const data = await responseBody.json()

      if (data.success) {
        return data.body.form
      } else {
        return 'SaveError'
      }
    } catch (error) {
      errorTrackingService.trackAPIError(error, '/admin/setMedicalHistory', 'POST')
      if (error.message === 'Network Error') {
        return 'NetworkError'
      } else {
        return 'SaveError'
      }
    }
  }

  const postAnswersPregnancyCalculator = async (body, id) => {
    const idToken = await getIdTokenClaims()

    try {
      const resp = post({
        apiName: baseUrl,
        path: '/api/v2/pregnancies/calculator',
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          },
          body
        }
      })
      const { body: responseBody } = await resp.response
      const data = await responseBody.json()

      if (data.success === false) {
        const error = new Error(data.message || 'API returned success: false')
        error.isAPIError = true
        error.response = { status: 200, data }
        errorTrackingService.trackAPIError(error, '/api/v2/pregnancies/calculator', 'POST')
        return 'MiscalculationError'
      }

      data.data.selection = Object.prototype.hasOwnProperty.call(body, 'sdg') ? 'sdg' : 'fum or fpp'
      setSaveResponse(data.data)
      return true
    } catch (error) {
      errorTrackingService.trackAPIError(error, '/api/v2/pregnancies/calculator', 'POST')
      return 'MiscalculationError'
    }
  }
  return (
    <FormsContext.Provider
      value={{
        getFormQuestions,
        postAnswers,
        postAnswersPregnancyCalculator,
        saveResponse
      }}
    >
      {children}
    </FormsContext.Provider>
  )
}

export default FormsProvider
